import { render, staticRenderFns } from "./add-review-form.vue?vue&type=template&id=00eb367f&"
import script from "./add-review-form.vue?vue&type=script&lang=js&"
export * from "./add-review-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\OSPanel\\domains\\specialty.local\\local\\js\\specialty\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00eb367f')) {
      api.createRecord('00eb367f', component.options)
    } else {
      api.reload('00eb367f', component.options)
    }
    module.hot.accept("./add-review-form.vue?vue&type=template&id=00eb367f&", function () {
      api.rerender('00eb367f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/review/add-review-form.vue"
export default component.exports